import React from "react";
import moment from "moment";

const AnswerDate = ({ value }) => {
  if (!value) {
    return <p className="text-sm italic text-gray-400">No date</p>;
  }
  const parsed = moment(value);
  const display = parsed.isValid() ? parsed.format("MMMM D, YYYY") : value;
  return (
    <p className="text-sm text-gray-900 bg-gray-50 border border-gray-200 rounded px-2 py-1 inline-block">
      {display}
    </p>
  );
};

export default AnswerDate;
